import auth0Client from '../Auth/Auth';
import {
    CurrentAPI,
    CurrentReportingAPI,
    CurrentPdmAPI,
    CurrentLang,
    StringUtils
} from "common"

export const MagstimFetch = {
    get,
    getNoAuth,
    getAnalyticsWithOptionalGuids,
    postWithQuery,
    getAnalytics,
    getPdm,
    post,
    put,
    delete: _delete,
    setAccessToken,
    getAccessToken,
    downloadReport,
    downloadDetailedReport,
    downloadCSV,
    uploadCSV
};

var accessToken = undefined;

function setAccessToken(token){
    accessToken = token;
}

function getAccessToken(){
    if(accessToken !== undefined){
        return accessToken;
    }

    return auth0Client.getAccessToken();
}

function isAuthenticated(){
    if(accessToken !== undefined){
        return true;
    }

    return auth0Client.isAuthenticated();
}

function getAPI(url){
    return CurrentAPI();
}

function get(url, guidArg, defaultArg) {

    //console.log(`url=${url} guidArg=${guidArg} defaultArg=${defaultArg}`);

    if (undefined === guidArg) {

        return getImpl(url);

    }
    else {

        if(StringUtils.isGuid(guidArg)) {

            if (StringUtils.isGuid(defaultArg)) {
                return getImpl(`${url}/${guidArg}/${defaultArg}`);
            }
            else {
                return getImpl(`${url}/${guidArg}`);
            }
        }
        else{

            if (undefined === defaultArg) {
                defaultArg = 'default';
            }
         
            return getImpl(`${url}/${defaultArg}`);

        }
    }
}

function getUrlWithBody(url, body) {
    // console.log(`getUrlWithBody url = ${url} body =`, body);
    if(isAuthenticated()){
        // Using GET with body results in:
        // TypeError: Failed to execute 'fetch' on 'Window': Request with GET/HEAD method cannot have body
        const requestOptions = getRequestOptions('POST', body);
        // console.log(`getUrlWithBody url = ${url} requestOptions =`, requestOptions);
        return fetch(url, requestOptions).then(handleResponse);
    }
    return Promise.reject("Not Authenticated");
}

function getUrl(url) {
    if(isAuthenticated()){
        const requestOptions = getRequestOptions();
        return fetch(url, requestOptions).then(handleResponse);
    }
    return Promise.reject("Not Authenticated");
}

function getAnalytics(endpoint, guid, subEndpoint) {
    var url = `${CurrentAPI()}${endpoint}`;
    if (undefined !== guid) {
        url = `${url}/${guid}`;
    }
    if (undefined !== subEndpoint) {
        url = `${url}/${subEndpoint}`;
    }
    return getUrl(url);
}


function getPdm(endpoint, guid) {
    var url = `${CurrentPdmAPI()}${endpoint}`;
    if (undefined !== guid) {
        url = `${url}/${guid}`;
    }
    return getUrl(url);
}

function getAnalyticsWithOptionalGuids(endpoint,guids) {
    return getWithOptionalGuids(CurrentAPI(), endpoint, guids);
}

function getWithOptionalGuids(serviceUrl,endpoint,guids) {
    var url = `${serviceUrl}${endpoint}`;
    return getUrlWithBody(url, guids);
}

export function getRequestOptions(method, body) {
    
    if (undefined === method) {
        method = 'GET';
    }

    const requestOptions = {
        method: method,
        headers: { 
            'Authorization': 'Bearer ' + getAccessToken(),
            'Accept': 'application/json',
            'Content-Type': 'application/json' },
    };  
    
    if (undefined !== body) {
        requestOptions.body = JSON.stringify(body);
    }

    // console.log('getRequestOptions', requestOptions)

    return requestOptions;
}

function getNoAuth(url) {
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    };
    return fetch(CurrentAPI() + url, requestOptions).then(handleResponse);
}

function getImpl(url) {

    //console.log(`url=${url}`);
    
    if(isAuthenticated()){
        const requestOptions = getRequestOptions();
        return fetch(getAPI(url) + url, requestOptions).then(handleResponse);
    }

    return Promise.reject("Not Authenticated");
}

function downloadReport(url, guidArg) {

    //console.log(`url=${url}`);
 
    if(isAuthenticated()) {
            
        var fullUrl = CurrentReportingAPI() + url;
        if(StringUtils.isGuid(guidArg)) {
            fullUrl += `/${guidArg}`;
        }

        const requestOptions = {
            method: 'GET',
            headers: { 
                'Authorization': 'Bearer ' + getAccessToken(),
                'Content-Type': 'application/pdf'
            },
        };

        return fetch(fullUrl, requestOptions).then(handleFileResponse);
    }

    return Promise.reject("Not Authenticated");
}

function downloadDetailedReport(url, postBody) {

    //console.log(`url=${url}`);
 
    if(isAuthenticated()) {
            
        var fullUrl = CurrentReportingAPI() + url;
        const requestOptions = getRequestOptions('POST', postBody)

        return fetch(fullUrl, requestOptions).then(handleFileResponse);
    }

    return Promise.reject("Not Authenticated");
}


function downloadCSV(url) {

    //console.log(`url=${url}`);
 
    if(isAuthenticated()) {
            
        var fullUrl = CurrentAPI() + url;

        const requestOptions = {
            method: 'GET',
            headers: { 
                'Authorization': 'Bearer ' + getAccessToken(),
                'Content-Type': 'application/csv'
            },
        };

        return fetch(fullUrl, requestOptions).then(handleFileResponse);
    }

    return Promise.reject("Not Authenticated");
}

function uploadCSV(url, body) {

    //console.log(`url=${url}`);
 
    if(isAuthenticated()) {
            
        var fullUrl = CurrentAPI() + url;

        const requestOptions = {
            method: 'POST',
            headers: { 
                'Authorization': 'Bearer ' + getAccessToken()
            },
            body:body
        };

        return fetch(fullUrl, requestOptions).then(handleResponse);
    }

    return Promise.reject("Not Authenticated");
}

// Only used from Contact.jsx, goes to AnalyticsWebApi
function post(url, body) {

    // console.log(`url=${url}`, body);

    if(isAuthenticated()){
        const requestOptions = getRequestOptions('POST', body);
        return fetch(getAPI(url) + url, requestOptions).then(handleResponse);
    }

    return Promise.reject("Not Authenticated");
}

function postWithQuery(endpoint, body, query) {

    // console.log(`endpoint=${endpoint}`, body, query);

    if(isAuthenticated()){
        var url = `${getAPI()}${endpoint}`;

        if (undefined !== query) {

            var queryParts = [];

            for (const param in query) {
                queryParts.push(`${param}=${query[param]}`);
            }

            url = `${url}?${encodeURI(queryParts.join('&'))}`;
        }

        const requestOptions = getRequestOptions('POST', body);
        return fetch(url, requestOptions).then(handleResponse);
    }

    return Promise.reject("Not Authenticated");
}

// Updates DB, goes to PdmWebApi
function put(endpoint, guid, body) {
    // console.log(`endpoint=${endpoint} guid=${guid}`, body);
    const url = `${endpoint}/${guid}`;
    if(isAuthenticated()){
        const requestOptions = getRequestOptions('PUT', body);
        return fetch(CurrentPdmAPI() + url, requestOptions).then(handleResponse);    
    }

    return Promise.reject("Not Authenticated");
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(endpoint, guid) {
    var url = `${endpoint}/${guid}`;
    if(isAuthenticated()){
        const requestOptions = {
            method: 'DELETE',
            headers: { 
                'Authorization': 'Bearer ' + getAccessToken(),
                'Content-Type': 'application/json' },
            }

            return fetch(getAPI(url)   + url, requestOptions).then(handleResponse);
    };
    
    return Promise.reject("Not Authenticated");
}

// helper functions
function handleResponse(response) {
    try{
        return response.text().then(text => {
            // The response much be JSON and OK otherwise reject
            try{         
                const data = text && JSON.parse(text);
                
                if (!response.ok) {

                    if(response.status === 500){
                        // Try to localize 500 internal server errors
                        var localizedError;
                        if ((undefined !== data.error_msg) && (null !== data.error_msg)) {
                            localizedError = StringUtils.format(CurrentLang()[data.error_msg], data.args);
                        }
                        else if ((undefined !== data.localised_error_msg) && (null !== data.localised_error_msg)) {
                            localizedError = data.localised_error_msg;
                        }

                        if(localizedError !== undefined){
                            return Promise.reject(localizedError); 
                        }
                    }
                     
                    const error = (data && data.Message) || response.statusText;
                    return Promise.reject(error);
                }

                return data;
            }catch(error){
                return Promise.reject(text);
            }
        });
    }
    catch(error){
        return Promise.reject(error);
    }
}

function getFilenameFromContentDisposition(contentDisposition) {
    console.log(`getFilenameFromContentDisposition contentDisposition=`, contentDisposition);
    // attachment; filename="Patient Reports - 20210712-153401.zip"

    const prefix = "attachment; filename=";
    if (contentDisposition.startsWith(prefix)) {
        return contentDisposition.substring(prefix.length);
    }
    else {
        return undefined;
    }
}
function handleFileResponse(response) {

    const contentDisposition = response.headers.get('content-disposition');
    const filename = StringUtils.removeQuotes(getFilenameFromContentDisposition(contentDisposition));

    try{
        return response.blob().then(blob => {

            // console.log('handleFileResponse', response);

            if (response.ok) {
                blob.filename = filename;
                return blob;
            }
            else {
                return Promise.reject(response.statusText);
            }
        })
    }
    catch(error){
        // console.log('handleFileResponse', response, error);
        return Promise.reject(error);
    }
}